// Fixture data for the "Or open a sample" list in CaptureModal — entirely
// fabricated documents for previewing what the ingest pipeline UI looks
// like, never written to a real Ingest Queue. Trimmed from the prototype's
// DOCS object: no per-field issue annotations, no blast-radius text, no
// sequence-gap blocker, no countdown trigger — those drive the prototype's
// full review page and alert banner, neither of which exists in this app.
// See docs/superpowers/specs/2026-08-04-sample-upload-design.md.

export interface SampleDoc {
  key: string;
  file: string;
  desc: string;
  size: string;
  sha: string;
  type: string;
  typeConf: number;
  entity: string;
  entityConf: number;
  risk: string;
  nItems: number;
  warningCount: number;
  indexOnly: boolean;
  chunks?: number;
}

export const SAMPLE_DOCS: Record<string, SampleDoc> = {
  invoice: {
    key: 'invoice',
    file: 'INV-4417_ArcTide_Jul2026.pdf',
    desc: '412 KB · invoice',
    size: '412 KB',
    sha: 'a3f9c1e8b204d7f16c8a90e3',
    type: 'Invoice',
    typeConf: 96,
    entity: 'Contract 70CTD024C00000019 · CLIN 0002',
    entityConf: 91,
    risk: 'critical',
    nItems: 9,
    warningCount: 4,
    indexOnly: false,
  },
  roster: {
    key: 'roster',
    file: 'Team_Roster_Update_Aug2026.xlsx',
    desc: '88 KB · staffing roster update',
    size: '88 KB',
    sha: '7c21e04ab9f3d558e1207a4c',
    type: 'Staffing roster update',
    typeConf: 94,
    entity: 'Project · ICE OCIO Modernization',
    entityConf: 89,
    risk: 'elevated',
    nItems: 8,
    warningCount: 3,
    indexOnly: false,
  },
  mod: {
    key: 'mod',
    file: 'P00007_SF30_70CTD024.pdf',
    desc: '304 KB · contract modification',
    size: '304 KB',
    sha: 'e5b8330c7a1f49d2b06ce8f1',
    type: 'Contract modification (SF-30)',
    typeConf: 99,
    entity: 'Contract 70CTD024C00000019',
    entityConf: 98,
    risk: 'critical',
    nItems: 8,
    warningCount: 3,
    indexOnly: false,
  },
  ims: {
    key: 'ims',
    file: 'IMS_Rev12_Aug2026.xml',
    desc: '2.4 MB · integrated master schedule',
    size: '2.4 MB',
    sha: '1d0fa77e58cb3921ac4e6b80',
    type: 'Integrated master schedule',
    typeConf: 98,
    entity: 'Project · ICE OCIO Modernization · Rev 12',
    entityConf: 96,
    risk: 'elevated',
    nItems: 62,
    warningCount: 0,
    indexOnly: false,
  },
  cure: {
    key: 'cure',
    file: 'Cure_Notice_70CTD024.pdf',
    desc: '156 KB · cure notice',
    size: '156 KB',
    sha: '9ab4c210ef7d6835ba0192cc',
    type: 'Cure notice',
    typeConf: 88,
    entity: 'Contract 70CTD024C00000019',
    entityConf: 97,
    risk: 'critical',
    nItems: 6,
    warningCount: 3,
    indexOnly: false,
  },
  qasp: {
    key: 'qasp',
    file: 'QASP_Final_v3.pdf',
    desc: '1.1 MB · indexed only',
    size: '1.1 MB',
    sha: '44c9e1b7302ad6f85be03917',
    type: 'Unclassified — indexed',
    typeConf: 41,
    entity: 'Contract 70CTD024C00000019',
    entityConf: 86,
    risk: 'low',
    nItems: 0,
    warningCount: 0,
    indexOnly: true,
    chunks: 96,
  },
};

export const SAMPLE_ORDER: string[] = ['invoice', 'roster', 'mod', 'ims', 'cure', 'qasp'];
